<template>
    <div id="app">
        <div id="scroll-view">
            <MainHeader
                :color="menu.isOpen ? 'red' : ($route.name === 'Home' && offset < 20) ? 'white' : 'grey'"
                :display="menu.isOpen ? 'menu' : 'default'"
                @offset="_ => offset = _"
                v-if="$route.params.locale"
            />
            <transition name="page" mode="out-in">
                <keep-alive :include="['page', 'contact']">
                    <router-view :class="[$route.name === 'Home' && 'home-view']" :key="$route.meta.id || $route.name + $i18n.locale"/>
                </keep-alive>
            </transition>
            <div class="page-cover">
                <div class="page-cover-after">
                    <div class="page-loader"></div>

                </div>
            </div>
        </div>
        <transition
            name="main-menu"
        >
            <MainMenu v-if="menu.isOpen"/>
        </transition>
        <PopIn
            v-if="popin.state"
            :data="popin.data"
        />
        <CookieBanner/>
    </div>
</template>

<script>
import MainHeader from '@/components/MainHeader'
// import MainFooter from '@/components/MainFooter'
import MainMenu from '@/components/MainMenu'
import CookieBanner from '@/components/CookieBanner'
import PopIn from '@/views/PopIn'
import {menu, popin} from '@/store/index.js'
// import { getLocale } from '@/store/api/index'
export default {
    name: 'app',
    components: {
        MainHeader,
        // MainFooter,
        MainMenu,
        PopIn,
        CookieBanner
    },
    data() {
        return {
            menu,
            popin,
            offset: 0
        }
    },
    watch: {
        $route() {
            if (this.menu.isOpen) {
                this.menu.isOpen = false
            }
        },
        '$route.params.locale': {
            handler: function (locale) {
                if(locale) {
                    this.$i18n.locale = locale
                    document.documentElement.setAttribute('lang', locale)
                    // getLocale({
                    //         lang: locale
                    //     })
                    //     .then((res) => {
                    //         this.$i18n.setLocaleMessage(locale, res.locale)
                    //     })
                }
            },
            immediate: true
        }


    },
    created() {
        if(this.$route.query.preview) {
            if(this.$route.name === 'Home') {
                this.$router.replace({
                    name: 'Preview',
                    params: {
                        id: this.$route.query.p || this.$route.query.preview_id
                    },
                    query: this.$route.query
                })
            }
        }
    },
    metaInfo() {
        return {
            titleTemplate: (titleChunk) => {
                return titleChunk ? `${titleChunk} | Soletanche Bachy` : 'Soletanche Bachy'
            },
            meta: [
                {
                    'property': 'title',
                    'content': 'Soletanche Bachy'
                },
                {
                    'property': 'og:url',
                    'content':  process.env.VUE_APP_URL + this.$router.currentRoute.path,
                    'vmid': 'og:url'
                },
                {
                    'property': 'og:title',
                    'content': 'Soletanche Bachy',
                    'vmid': 'og:title'
                },
                {
                    'property': 'og:image',
                    'content': 'https://www.soletanche-bachy.com/assets/3387×1905-PPT-Femmes-Colombie.jpg',
                    'vmid': 'og:image'
                },
                {
                    'property': 'og:description',
                    'content': this.$t('seo.description'),
                    'vmid': 'og:description'
                }
            ],
            link: [
                {
                    'rel': 'canonical',
                    'href': process.env.VUE_APP_URL + this.$router.currentRoute.path,
                    vmid: 'canonical'
                }
            ]
        }
    }
}
</script>

<style lang="sass">
@import "@/styles/reset.sass"
@import "@/styles/fonts.sass"
@import "@/styles/styles.sass"
#app
    // height: 100%
    overflow: hidden
// #scroll-view
    // height: 100%
    // overflow-y: auto
    // -webkit-overflow-scrolling: touch

.page-view
    @media print
        page-break-before: avoid
        break-before: avoid
        min-height: 0
.page-cover
    pointer-events: none
    position: fixed
    top: 0%
    left: 0
    width: 100%
    height: 100%
    z-index: 12
    overflow: hidden
    @media print
        display: none
    &:before
        content: ""
        display: block
        width: 100%
        height: 100%
        background-color: rgb(243, 243, 250)
        transform: translateY(100%)
        will-change: transform, transition
        position: absolute
        top: 0
        left: 0
        z-index: 1
    .page-cover-after
        content: ""
        display: block
        width: 100%
        height: 100%
        background-color: rgb(243, 243, 250)
        transform: translateY(0%)
        will-change: transform, transition
        position: absolute
        top: 0
        left: 0
        z-index: 0
        overflow: hidden
    .page-loader
        position: absolute
        right: 0
        height: 100%
        top: 0
        transform: translateY(0%)
        width: 10px
        background-color: rgb(255, 43, 43)
        z-index: 2z
        will-change: transform, transition

.loaded
    & ~ .page-cover
        .page-cover-after
            transition: transform .5s .5s
            transform: translateY(-100%)
        .page-loader
            transition: transform .5s .5s
            transform: translateY(-100%)
.page-enter-active
    transition: opacity .5s .5s
    & ~.page-cover
        .page-cover-after
            opacity: 1
        .page-loader
            transition: transform .5s
.page-enter
    & ~.page-cover
        .page-loader
            transform: translateY(0%)
.page-leave-active
    transition: visibility .5s
    & ~.page-cover
        &:before
            transition: transform .5s
        .page-cover-after
            opacity: 0
        .page-loader
            transform: translateY(100%)
.page-leave-to
    & ~ .page-cover
        &:before
            transform: translateY(0%)
</style>
